module.exports = __webpack_public_path__ + "static/media/tempesta.b0a1d433.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tempesta.png
// module id = 115
// module chunks = 0